import {
  getUser as getAmalgamUser,
  getUserEmail,
  getUserIdFromAmalgam,
  getUserName,
  getUserPhone
} from './Amalgam';
import { doesNativeConnectorExist, nativeChatOnWhatsApp } from './NativeConnector';
import { startChat as startWhatsAppChat } from './WhatsApp';

export const getUser = () => getAmalgamUser() || {};
export const getUserId = () => getUser().id || getUserIdFromAmalgam();
export const getName = () => getUser().name || getUserName();
export const getEmail = () => getUser().email || getUserEmail();
export const getPhone = () => getUser().phone || getUserPhone();
export const getProfileImage = () => getUser().profileImageURL;
export const startChat = ({ message, openInNative, callNativeHandler = false } = {}) => {
  let phone = getUserPhone();

  if (phone) {
    phone = phone.slice(1);
  }

  if (!openInNative) {
    return {
      message,
      phone
    };
  }

  if (callNativeHandler && doesNativeConnectorExist()) {
    nativeChatOnWhatsApp(message, phone);
    return;
  }

  startWhatsAppChat(message || 'Hi', phone);
};
